import { useEffect, useState } from 'react';
import { Alert, Button, FileInput, Group, Modal, Select, Stack, Text, TextInput, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconFileDescription, IconInfoCircle, IconUpload, IconX } from '@tabler/icons-react';
import api from '../../api/axiosConfig';

const categoryLabels = { PERSONNEL: 'Özlük', OHS: 'İSG', EMPLOYMENT: 'İşe Giriş' };

export default function UploadDocumentModal({ opened, onClose, employee, onUpload }) {
  const [documentTypes, setDocumentTypes] = useState([]);
  const [error, setError] = useState('');
  const form = useForm({
    initialValues: { document_type_id: null, file: null, expires_at: '', note: '' },
    validate: {
      document_type_id: (value) => !value ? 'Evrak türünü seçin' : null,
      file: (value) => !value ? 'Yüklenecek dosyayı seçin' : null,
      expires_at: (value, values) => {
        const type = documentTypes.find((item) => String(item.id) === values.document_type_id);
        return type?.requires_expiry && !value ? 'Bu evrak türü için geçerlilik tarihi zorunludur' : null;
      },
    },
  });

  useEffect(() => {
    if (!opened) return;
    setError(''); form.reset();
    api.get('/hr/document-types')
      .then((response) => setDocumentTypes(response.data))
      .catch((err) => setError(err.response?.data?.detail || 'Evrak türleri alınamadı.'));
  }, [opened, employee?.id]);

  if (!employee) return null;
  const selectedType = documentTypes.find((item) => String(item.id) === form.values.document_type_id);
  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append('employee_id', String(employee.id));
    formData.append('document_type_id', values.document_type_id);
    formData.append('file', values.file);
    if (values.expires_at) formData.append('expires_at', values.expires_at);
    if (values.note.trim()) formData.append('note', values.note.trim());
    try { await onUpload?.(formData); form.reset(); }
    catch (err) { setError(err.response?.data?.detail || 'Evrak yüklenemedi.'); }
  };
  const handleClose = () => { form.reset(); setError(''); onClose(); };

  return <Modal opened={opened} onClose={handleClose} title={<Text fw={800} size="lg">Evrak Yükle</Text>} size="lg" closeButtonProps={{ icon: <IconX size={20} /> }}>
    <form onSubmit={form.onSubmit(handleSubmit)}><Stack gap="md">
      <Group p="sm" bg="blue.0" style={{ borderRadius: 8 }}><IconFileDescription size={24} color="var(--mantine-color-blue-6)" /><div><Text size="xs" c="blue.8" fw={700} tt="uppercase">İşlem Yapılan Personel</Text><Text size="sm" fw={600}>{employee.name || `${employee.first_name} ${employee.last_name}`} - {employee.role || employee.job_title?.name || employee.position || '-'}</Text></div></Group>
      {error && <Alert color="red">{String(error)}</Alert>}
      <Alert variant="light" color="blue" title="Evrak Takibi" icon={<IconInfoCircle />}>Zorunlu evraklar ve geçerlilik kuralları İK Tanımları ekranından yönetilir.</Alert>
      <Select withAsterisk searchable label="Evrak Türü" placeholder="Evrak türünü seçin" data={documentTypes.map((item) => ({ value: String(item.id), label: `${item.name} · ${categoryLabels[item.category] || item.category}${item.is_required ? ' · Zorunlu' : ''}` }))} {...form.getInputProps('document_type_id')} />
      {selectedType?.requires_expiry && <TextInput withAsterisk label="Geçerlilik Bitiş Tarihi" type="date" {...form.getInputProps('expires_at')} />}
      {!selectedType?.requires_expiry && <TextInput label="Geçerlilik Bitiş Tarihi" description="Varsa girilebilir" type="date" {...form.getInputProps('expires_at')} />}
      <Textarea label="Not" placeholder="Evrakla ilgili açıklama (isteğe bağlı)" {...form.getInputProps('note')} />
      <FileInput withAsterisk label="Dosya Seç" placeholder="PDF, görsel veya ofis belgesi" accept="application/pdf,image/png,image/jpeg,.doc,.docx,.xls,.xlsx" leftSection={<IconUpload size={18} />} clearable {...form.getInputProps('file')} />
    </Stack><Group justify="flex-end" mt="xl" pt="md"><Button variant="default" onClick={handleClose}>İptal</Button><Button type="submit" leftSection={<IconUpload size={18} />}>Evrağı Yükle</Button></Group></form>
  </Modal>;
}
